import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
    selector: 'app-menu-view',
    templateUrl: './menu-view.component.html',
    styleUrls: ['./menu-view.component.scss']
})
export class MenuViewComponent implements OnInit {

    constructor(
		public loading: LoadingService,
		private http: HttpService,
		private modalService: NgbModal
    ) { }
	@ViewChild('deleteModal') deleteModal: any;
	private apiPath = 'navigation';
	data: any = {};
	query: any = {
	    q: null,
	    limit: 10,
	    page: 1
	}
	isSearch: boolean = false;
	util = UtilitiesService;
	deleteDialog: any = {
	    ids: [],
	    isDeleting: false,
	    modal: null,
	    show: (ids: Array<any>) => {
	        this.deleteDialog.ids = ids;
	        this.deleteDialog.modal = this.modalService.open(this.deleteModal, { keyboard: false, backdrop: 'static', centered: true });
	    },
	    submit: () => {
	        this.deleteDialog.isDeleting = true;
	        let urlParameters = Object.entries(this.query.getValue()).filter(k => { return k[1] != null }).map(e => e.join('=')).join('&');
	        this.http.Delete(this.apiPath+'/delete?' + urlParameters, this.deleteDialog.ids).then((r: any) => {
	            this.deleteDialog.isDeleting = false;
	            if (r.success) {
	                this.data = r?.response?.result || {};
	                this.deleteDialog.modal.close();
	            }
	        });
	    }
	};
	searchData(ev: any): void {
	    if (ev?.keyCode === 27) {
	        this.query.q = null;
	        this.isSearch = false;
	        this.getData();
	    }
	    if (ev?.keyCode === 13) {
	        this.getData();
	    }
	}
	getData(): void {
	    this.http.Get(this.apiPath, this.query).then((r: any) => {
	        if (r.success) {
	            this.data = r?.response?.result || {};
	        }
	    });
	}
	ngOnInit(): void {
	    this.loading.start();
	    this.getData();
	}

}
